module.exports = __webpack_public_path__ + "static/card-img-8-0d02cf76ab632a7dc961bccf14fb0e94.jpg";